import { create } from 'zustand';

/**
 * One line, briefly, from anywhere: "Added to the jam". For the moments
 * where the thing that happened is not on the screen the person is
 * looking at. The next one replaces the last; nothing queues.
 */
interface NoticeState {
  text: string | null;
  /** A link the notice is, when it is one. */
  to: string | null;
  show: (text: string, to?: string) => void;
  clear: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useNotice = create<NoticeState>((set) => ({
  text: null,
  to: null,

  show: (text, to) => {
    if (timer !== null) clearTimeout(timer);

    set({ text, to: to ?? null });
    timer = setTimeout(() => set({ text: null, to: null }), 3200);
  },

  clear: () => {
    if (timer !== null) clearTimeout(timer);

    set({ text: null, to: null });
  },
}));
